import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import moment from 'moment/moment';
import Section from './Section';
import SectionColumn from './SectionColumn';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  commentary: {
    paddingBottom: theme.spacing(1),
    maxHeight: 400,
    overflowY: 'auto',
  },
});

const CommentarySection = ({
  className,
  classes,
  commentary,
  lastUpdated,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Section className={classes.commentary}>
        <SectionColumn header={'Facet\'s Take'} value={commentary} variant={'richTextNote'} />
      </Section>
      <Text variant={'body'} color={'lightGray'} align={'left'} value={`Updated ${moment(lastUpdated).format('MM/DD/YY')}`} />
    </Box>
  );
};

CommentarySection.defaultProps = {
  className: '',
};

CommentarySection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  commentary: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
};

export default withStyles(styles)(CommentarySection);
